export const DISCUSSION = 'discussion';
export const QUESTION = 'question';

export const isDiscussion = (postType = DISCUSSION) => postType === DISCUSSION;
export const isQuestion = postType => postType === QUESTION;
